import {
  API_REVIEW_FORM,
  API_REVIEW_FORM_AI_AUTOFILL,
  // API_REVIEW_FORM_AI_PROMPT,
  API_REVIEW_FORM_APPRAISER_ADD_LOGS,
  API_REVIEW_FORM_BY_ID,
  API_REVIEW_FORM_LOG_BY_ID,
  API_REVIEW_FORM_TEMPLATE_BY_ID,
  API_REVIEW_FORM_TEMPLATE_ORDER_BY_ID,
  API_REVIEW_FORM_TEMPLATE_VISIBLE_BY_ID,
  API_REVIEW_FORM_TEMPLATE_VISIBLE_LOGIC_BY_ID,
  API_REVIEW_FORM_TEMPLATES,
} from 'config'
import type { ReviewFormCategory } from 'pages/Admin'
import { type ReviewFormReport, type ReviewFormReporterSection } from 'pages/Loan/Underwriting/ReviewForm/constants'
import Api from 'services/api'

import { getSetting, updateSetting } from './admin'

export type { ReviewFormReport, ReviewFormReporterSection }

export const getReviewFormCategories = async (): Promise<ReviewFormCategory[]> => {
  const categories = await getSetting('REVIEW_FORM_CATEGORIES')
  try {
    const values = categories || {}
    return JSON.parse(values.value) || []
  } catch {
    return []
  }
}

export const setReviewFormCategories = async (values: ReviewFormCategory[]) => {
  return updateSetting('REVIEW_FORM_CATEGORIES', JSON.stringify(values))
}

export const getReviewFormReporterSection = async () => {
  const setting = await getSetting('REVIEW_FORM_REPORTER_SECTION')
  try {
    return JSON.parse(setting?.value)
  } catch {
    return { label1: '', reports: [] }
  }
}

export const setReviewFormReporterSection = async (values: ReviewFormReporterSection) => {
  return updateSetting('REVIEW_FORM_REPORTER_SECTION', JSON.stringify(values))
}

export const getReviewFormTemplates = () => {
  return Api.get(API_REVIEW_FORM_TEMPLATES)
}

export const submitReviewFormTemplate = (id: number, data: Record<string, any>) => {
  if (id == 0) return Api.post(API_REVIEW_FORM_TEMPLATES, data)
  return Api.put(API_REVIEW_FORM_TEMPLATE_BY_ID, data, { id })
}

export const deleteReviewFormTemplate = (id: number) => {
  return Api.delete(API_REVIEW_FORM_TEMPLATE_BY_ID, {}, { id })
}

export const updateReviewFormTemplateOrder = (id: number, order: number) => {
  return Api.put(API_REVIEW_FORM_TEMPLATE_ORDER_BY_ID, { order }, { id })
}

export const toggleReviewFormTemplateVisible = (id: number) => {
  return Api.put(API_REVIEW_FORM_TEMPLATE_VISIBLE_BY_ID, {}, { id })
}

export const updateReviewFormTemplateVisibleLogic = (
  id: number,
  visibleLogic: { fieldOrigin: string; fieldKey: string; value: string | number | boolean }[][],
) => {
  return Api.put(API_REVIEW_FORM_TEMPLATE_VISIBLE_LOGIC_BY_ID, { visibleLogic }, { id })
}

export const getReviewForm = (index: number = 0) => {
  return Api.get(API_REVIEW_FORM, { index })
}

export const updateReviewForm = (id: number, key: string, value: any) => {
  return Api.put(API_REVIEW_FORM_BY_ID, { key, value }, { id })
}

export const updateReviewFormData = (id: number, data: Record<string, any>) => {
  return Api.put(API_REVIEW_FORM_BY_ID, { key: 'data', value: data }, { id })
}

export const deleteReviewForm = (id: number) => {
  return Api.delete(API_REVIEW_FORM_BY_ID, {}, { id })
}

export const getReviewFormLogs = (id: number, key: string) => {
  return Api.get(API_REVIEW_FORM_LOG_BY_ID, { key }, { id })
}

export const postReviewFormAppraiserAddLogs = (id: number, fields: Record<string, any>) => {
  return Api.post(API_REVIEW_FORM_APPRAISER_ADD_LOGS, { fields }, { id })
}

export const getReviewFormAiAutoFill = (id: number = 0) => {
  return Api.get(API_REVIEW_FORM_AI_AUTOFILL, {}, { id })
}

export const postReviewFormAiAutoFill = (
  id: number = 0,
  files: Record<string, any>[] = [],
  options: Record<string, any> = {},
) => {
  return Api.post(API_REVIEW_FORM_AI_AUTOFILL, { files, options }, { id }, { timeout: 0 })
}

export const postReviewFormAiAutoFillFields = (id: number = 0, data: Record<string, any> = {}) => {
  return Api.put(API_REVIEW_FORM_AI_AUTOFILL, { data }, { id })
}

// export const postReviewFormAiPrompt = (
//   id: number = 0,
//   data: { prompt: string; files: Record<string, any>[] },
//   history: Record<string, any>[] = [],
// ) => {
//   return Api.post(API_REVIEW_FORM_AI_PROMPT, { ...data, history: history || [] }, { id }, { timeout: 0 })
// }
